export const CHANGE_LOADING = 'CHANGE_LOADING';

const changeLoadingAction = (isLoading) => (dispatch) => {
    dispatch({
        type: CHANGE_LOADING,
        viewtype: { isLoading }
    });
};

export default changeLoadingAction;
